var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAnalysis(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.192,
    height: 18.763,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_254",
    "data-name": "Rectangle 254",
    transform: "translate(-2.101 -1.489)",
    style: {
      strokeWidth: ".7px",
      fill: "none",
      stroke: "#5e6a8f"
    },
    d: "M0 0h26.192v18.763H0z"
  })), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".cls-3,.cls-4,.cls-5,.cls-6{fill:none;stroke:currentColor}.cls-6{stroke-width:.7px}.cls-3,.cls-4,.cls-5,.cls-6{stroke-linecap:round}.cls-3,.cls-5,.cls-6{stroke-miterlimit:10}.cls-3{stroke-width:.8px}"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_136",
    "data-name": "Group 136",
    transform: "translate(2.101 1.489)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_135",
    "data-name": "Group 135",
    style: {
      clipPath: "url(#clip-path5)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    className: "cls-3",
    d: "M18.526 4.766a6.948 6.948 0 1 1-9.093-3.725 6.948 6.948 0 0 1 9.093 3.725Z",
    transform: "translate(-.826 -.08)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    "data-name": "Path 73",
    className: "cls-4",
    d: "m0 0 3.05 2.38",
    transform: "rotate(-2 164.933 -422.026)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Line_191",
    "data-name": "Line 191",
    className: "cls-5",
    transform: "translate(9.913 5.842)",
    d: "M0 2.7 2.433 0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    "data-name": "Path 74",
    className: "cls-4",
    d: "m0 0 2.657 2.082",
    transform: "translate(4.59 6.65)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Line_193",
    "data-name": "Line 193",
    className: "cls-6",
    transform: "translate(1.925 6.33)",
    d: "m0 0 2.48 1.833"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    className: "cls-6",
    d: "M2.549 5.283a1.1 1.1 0 1 1-1.1-1.1 1.1 1.1 0 0 1 1.1 1.1Z",
    transform: "translate(-.451 .119)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    className: "cls-5",
    d: "M11.491 11.107a1.451 1.451 0 1 1-1.45-1.45 1.45 1.45 0 0 1 1.45 1.45Z",
    transform: "translate(-1.373 -1.544)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    className: "cls-5",
    d: "M17.178 5.381a1.451 1.451 0 1 1-1.45-1.45 1.45 1.45 0 0 1 1.45 1.45Z",
    transform: "translate(-2.282 -.629)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    "data-name": "Path 72",
    className: "cls-3",
    d: "m26 14.715-5.033-3.548a6.958 6.958 0 0 1-2.026 3.167l4.9 3.451A1.878 1.878 0 0 0 26 14.715Z",
    transform: "translate(-3.028 -1.785)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalysis);
export default __webpack_public_path__ + "static/media/analysis.1d650bf3ea35ada718b5ec26a633e2a8.svg";
export { ForwardRef as ReactComponent };